import rawProjects from './projects.json';
import skillDescriptions from './skills.json';

export const CATEGORIES = ['Machine Learning', 'Research', 'Systems', 'Application/Website'];

// A filter label can cover more than one project type: a row still shows its own
// type ("Website" or "Application"), while one filter gathers both.
const TYPES_BY_CATEGORY = {
    'Application/Website': ['Application', 'Website'],
};

export const matchesCategory = (project, category) =>
    !category || (TYPES_BY_CATEGORY[category] || [category]).includes(project.cat);

/** A repo link beats the public flag; without either the project is private. */
const accessOf = (p) => (p.link ? 'repo' : p.ispublic ? 'public' : 'private');

export const PROJECTS = rawProjects.map((p) => ({
    id: p.title,
    name: p.title,
    cat: p.type,
    date: p.date,
    desc: p.desc || '',
    note: p.note || '',
    pill: p.pill || '',
    links: p.links || [],
    ongoing: !p.isfinished,
    link: p.link || '',
    access: accessOf(p),
    skills: p.skills || [],
}));

/** project id -> access, so a skill badge shows the same dot as its project. */
export const ACCESS_BY_PROJECT = Object.fromEntries(
    PROJECTS.map((p) => [p.id, p.access])
);

// Skills are inverted out of the projects rather than listed by hand, so the two
// pages can never disagree: editing a project's `skills` is the only input.
// Ranked by how many projects use each, most-used first; `weight` normalises
// that count to 0..1 for the type-size ramp.
const usesBySkill = new Map();
PROJECTS.forEach((p) => {
    p.skills.forEach((s) => {
        if (!usesBySkill.has(s)) usesBySkill.set(s, []);
        usesBySkill.get(s).push(p.id);
    });
});

const ranked = [...usesBySkill.entries()]
    .map(([name, uses]) => ({ name, uses, count: uses.length }))
    // Alphabetical within a tie, so equal counts have a stable order.
    .sort((a, b) => b.count - a.count || a.name.localeCompare(b.name));

const maxUses = ranked.length ? ranked[0].count : 1;

// Descriptions are keyed by skill name in skills.json. A skill with no entry
// there simply renders without one, the same as a project with no desc.
export const SKILLS = ranked.map((s) => ({
    ...s,
    weight: s.count / maxUses,
    desc: skillDescriptions[s.name] || '',
}));
